const RANK = {
    // 活跃榜
    ACTIVE: 1
};

const THEME = {
    LIGHT: 1,
    DARK: 3
};

const UP_DOWN_COLOR = {
    RED_UP: 0,
    GREEN_UP: 1
};

// 目前仅支持五个市场
const MARKET = {
    HK: 'HK', // 港股
    US: 'US', // 美股
    SG: 'SG', // 星股
    AU: 'AU', // 澳股
    JP: 'JP' // 日本
};

const INCREASE_TYPE = {
    CLOSE: 'day',
    CLOSE_5DAY: 'close_5day',
    CLOSE_10DAY: 'close_10day',
    CLOSE_20DAY: 'close_20day',
    CLOSE_60DAY: 'close_60day',
    CLOSE_120DAY: 'close_120day',
    CLOSE_250DAY: 'close_250day',
    CLOSE_MONTH: 'close_month',
    CLOSE_YEAR: 'close_year',
}

export { RANK, THEME, UP_DOWN_COLOR, MARKET, INCREASE_TYPE };
